var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h5',[_c('span',{staticClass:"prefix"},[_vm._v("Element and context:")]),_vm._v(" "+_vm._s(_vm.elementType)+" in "+_vm._s(_vm.contextItemTitle))])
}
var staticRenderFns = []

export { render, staticRenderFns }